import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import Signup from './components/signup/Signup.jsx';
import Dashboard from './components/dashboard/Dashboard.jsx';
import DriverDetails from './components/driverDetails/driverDetails.jsx';
import Vehicles from './components/vehicle/vehicle.jsx';
import DashboardCustomer from './components/dashboardCustomer/mainCustomer.jsx';
import DriverDocuments from './components/driverDocuments/driverDocuments.jsx';
import HomeScreenSettings from './components/homeScreenSettings/homeScreenSettings.jsx';
import HomeScreenDetails from './components/homeScreenSettings/homeScreenDetails.jsx';
import Fleets from './components/fleet/Fleet.jsx';
import Geofence from './components/geofence/Geofence.jsx';
import Corporate from './components/corporate/Corporate.jsx';
import ManagerSettings from './components/managerSettings/managerSettings.jsx';
import DynamicRidesPanel from './components/DynamicPanel/dynamicPanel.jsx';
import mainDashboard from './components/mainDashboard/mainDashboard.jsx';
import ScheduleRideSettings from './components/settingsScheduleRide/ScheduleRideSettings.jsx';
import SurgePricing from './components/surgePricing/SurgePricing.jsx';
import CustomZone from './components/customZone/customeZone.jsx';
import Dispatcher from './components/dispatcher/Dispatcher.jsx';
import DynamicAnalyticsReports from './components/analytics/analtyics.jsx';
import Layout from './Layout.jsx';
import GeneralSettings from './components/generalSettings/GeneralSettings.jsx';
import CitySettings from './components/citySettings/CitySettings.jsx';
import mapView from './components/mapView/MapView.jsx';
import Promotions from './components/promotions/Promotions.jsx';

// ProtectedRoute component
function ProtectedRoute({ element: Component, ...rest }) {
  const token = localStorage.getItem('token');
  
  return token ? <Component {...rest} /> : <Navigate to="/signup" replace />;
}

function App() {
  return (
    <div>
      <Routes>
        {/* Public route */}
        <Route path="/signup" element={<Signup />} />

        {/* Protected routes */}
        <Route path="/" element={<Layout />}>
          <Route index element={<ProtectedRoute element={Dashboard} />} />        {/* driver page */}
          <Route path="/driver-details" element={<ProtectedRoute element={DriverDetails} />} />      {/* driver details page */}
          <Route path="/vehicle" element={<ProtectedRoute element={Vehicles} />} />
          <Route path="/driver-documents" element={<ProtectedRoute element={DriverDocuments} />} />
          <Route path="/homescreen-settings" element={<ProtectedRoute element={HomeScreenSettings} />} />
          <Route path="/homescreen-details" element={<ProtectedRoute element={HomeScreenDetails} />} />
          <Route path="/fleets" element={<ProtectedRoute element={Fleets} />} />
          <Route path="/geofence" element={<ProtectedRoute element={Geofence} />} />
          <Route path="/corporate" element={<ProtectedRoute element={Corporate} />} />
          <Route path="/manager_settings" element={<ProtectedRoute element={ManagerSettings} />} />
          {/* Dynamic route for ride statuses */}
          <Route path="/rides/:status" element={<ProtectedRoute element={DynamicRidesPanel} />} />
          <Route path="/rider-details" element={<ProtectedRoute element={DashboardCustomer} />} />    {/* customer page */}
          <Route path="/mainDashboard" element={<ProtectedRoute element={mainDashboard} />} />     {/* dashboard page */}
          <Route path="/settings/schedule-ride" element={<ProtectedRoute element={ScheduleRideSettings} />} />
          <Route path="/surge-pricing" element={<ProtectedRoute element={SurgePricing} />} />
          <Route path="/custom-zone" element={<ProtectedRoute element={CustomZone} />} />
          <Route path="/dispatcher" element={<ProtectedRoute element={Dispatcher} />} />
          <Route path="/analytics" element={<ProtectedRoute element={DynamicAnalyticsReports} />} />
          <Route path="/general_settings" element={<ProtectedRoute element={GeneralSettings} />} />
          <Route path="/city_settings" element={<ProtectedRoute element={CitySettings} />} />
          <Route path="/mapView" element={<ProtectedRoute element={mapView} />} />
          <Route path="/promotions" element={<ProtectedRoute element={Promotions} />} />
        </Route>
       
      </Routes>
    </div>
  );
}

// Root component with Router
function Root() {
  return (
    <Router>
      <App />
    </Router>
  );
}

export default Root;
